import HotelSidebar from "../components/HotelSidebar";
import { useEffect, useState } from "react";

export default function HotelDashboard() {
  const [stats, setStats] = useState(null);
  const [bills, setBills] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard`,{
      credentials : "include"
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") {
          setStats(data.stats);
          setBills(data.recentBills || []);
        }
      })
      .catch(console.error);
  }, []);

  if (!stats) {
    return (
      <div className="flex min-h-screen w-full bg-amber-50">
        <HotelSidebar />
        <div className="flex-1 p-4">
          <p>Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex min-h-screen w-full bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/bg3.png')" }}
    >
      <HotelSidebar />

      {/* MAIN CONTENT */}
      <div className="ml-0 lg:ml-64 w-full flex-1 p-3 sm:p-4 md:p-6">
        <h1 className="text-xl sm:text-2xl font-bold text-amber-900 border border-yellow-500 rounded-full mb-6">
          🏨 Hotel Dashboard
        </h1>

        {/* TOP STATS */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          <Card title="Rooms Occupied" value={stats.occupied} color="red" />
          <Card title="Rooms Available" value={stats.available} color="green" />
          <Card title="Check-ins Today" value={stats.todayCheckins} color="red" />
          <Card title="Check-outs Today" value={stats.todayCheckouts} color="red" />
        </div>

        {/* REVENUE */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          <Revenue
            title="Today Rooms Collection 💵"
            value={stats.todayRoomsCharge}  
          />
          <Revenue
            title="Monthly Rooms Collection 💵"
            value={stats.monthlyRoomsCharge}
          />
          <Revenue title="Today Total Revenue" value={stats.todayRevenue} />
          <Revenue title="Monthly Total Revenue" value={stats.monthlyRevenue} />
            <Revenue title="Today Cash 💵" value={stats.todayCash} />
  <Revenue title="Today UPI" value={stats.todayUPI} />

  <Revenue title="Monthly Cash 📆" value={stats.monthlyCash} />
  <Revenue title="Monthly UPI 📆" value={stats.monthlyUPI} />
        </div>

        {/* RECENT BILLS */}
        <div className="bg-white rounded-xl shadow p-4 sm:p-6">
          <h2 className="text-base sm:text-lg font-semibold mb-4">
            🧾 Recent Hotel Bills
          </h2>

          {bills.length === 0 ? (
            <p className="text-sm text-gray-500">No recent bills</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm border min-w-[600px]">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border px-3 py-2 text-left">Bill No</th>
                    <th className="border px-3 py-2 text-left">Guest</th>
                    <th className="border px-3 py-2 text-left">Room</th>
                    <th className="border px-3 py-2 text-left">Amount</th>
                    <th className="border px-3 py-2 text-left">Status</th>
                    <th className="border px-3 py-2 text-left">
                      Check Out By
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {bills.map(b => (
                    <tr key={b.id}>
                      <td className="border px-3 py-2">H-{b.id}</td>
                      <td className="border px-3 py-2">{b.name}</td>
                      <td className="border px-3 py-2">{b.room_no}</td>
                      <td className="border px-3 py-2">
                        ₹ {Number(b.amount).toLocaleString()}
                      </td>
                      <td
                        className={`border px-3 py-2 font-bold ${
                          b.status === "paid"
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                      >
                        {b.status}
                      </td>
                      <td
                        className={`border px-3 py-2 font-medium ${
                          b.checkout_receptionist?.trim()
                            ? "text-gray-800"
                            : "text-red-600"
                        }`}
                      >
                        {b.checkout_receptionist?.trim()
                          ? b.checkout_receptionist
                          : "Advance"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* ---------- REUSABLE COMPONENTS ---------- */

function Card({ title, value, color }) {
  const colorMap = {
    red: "text-red-700",
    green: "text-green-700",
  };

  return (
    <div className="bg-white rounded-xl shadow p-4">
      <p className="text-xs sm:text-sm text-gray-500">{title}</p>
      <p className={`text-xl sm:text-2xl font-bold ${colorMap[color]}`}>
        {value}
      </p>
    </div>
  );
}

function Revenue({ title, value, danger }) {
  return (
    <div className="bg-white rounded-xl shadow p-4">
      <p className="text-xs sm:text-sm text-gray-500">{title}</p>
      <p
        className={`text-xl sm:text-2xl font-bold ${
          danger ? "text-red-700" : "text-green-700"
        }`}
      >
        ₹ {Number(value || 0).toLocaleString()}
      </p>
    </div>
  );
}
